module.exports = __webpack_public_path__ + "img/express-sf.b8eb6033.png";